/* TLY wishlist (K3). No dependencies. window.TLYWishlist = {add, remove, toggle, has, list, count, syncPhone}
   Guest list lives in localStorage['tly_wl'] = {v:1, id, items:[{p,h,v,t,i,pr,cap,av,at}], sms?:{state,masked}}.
   Server sync (K4/CONTRACT.md) only after the shopper gave a phone number. Add to cart goes through the real cart
   (fetch /cart/add - the IXTYOY engine intercepts window.fetch, so gifts/limits behave as on the product page). */
(function () {
  'use strict';
  if (window.TLYWishlist) return;
  var KEY = 'tly_wl', MAX = 100, mem = null;

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    var b = new Uint8Array(16); (window.crypto || {}).getRandomValues ? crypto.getRandomValues(b) : b.forEach(function (_, i) { b[i] = Math.random() * 256; });
    b[6] = (b[6] & 15) | 64; b[8] = (b[8] & 63) | 128;
    var h = Array.prototype.map.call(b, function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
    return h.slice(0, 8) + '-' + h.slice(8, 12) + '-' + h.slice(12, 16) + '-' + h.slice(16, 20) + '-' + h.slice(20);
  }
  function load() {
    var raw = null;
    try { raw = localStorage.getItem(KEY); } catch (e) { return mem || (mem = fresh()); }
    try { var d = JSON.parse(raw); if (d && d.v === 1 && Array.isArray(d.items)) return d; } catch (e) {}
    return fresh();
  }
  function fresh() { return { v: 1, id: uuid(), items: [] }; }
  var state = load();
  function save() {
    mem = state;
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
    render(); scheduleSync();
    try { document.dispatchEvent(new CustomEvent('tly:wishlist', { detail: { count: state.items.length } })); } catch (e) {}
  }
  function idx(p) { for (var i = 0; i < state.items.length; i++) if (String(state.items[i].p) === String(p)) return i; return -1; }

  var api = {
    list: function () { return state.items.slice(); },
    count: function () { return state.items.length; },
    has: function (p) { return idx(p) > -1; },
    add: function (it) {
      if (!it || !it.p || idx(it.p) > -1) return false;
      if (state.items.length >= MAX) state.items.pop();
      it.at = it.at || new Date().toISOString();
      state.items.unshift(it); save(); return true;
    },
    remove: function (p) { var i = idx(p); if (i < 0) return false; state.items.splice(i, 1); save(); return true; },
    toggle: function (it) { return api.has(it.p) ? (api.remove(it.p), false) : (api.add(it), true); },
    id: function () { return state.id; }
  };

  /* ---------- hearts + counters ---------- */
  function fromButton(b) {
    var v = b.getAttribute('data-variant');
    if (b.getAttribute('data-mode') === 'button') { // product page: follow the selected variant
      var f = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (f && f.value) v = f.value;
    }
    return { p: +b.getAttribute('data-tly-wl'), h: b.getAttribute('data-handle'), v: +v || 0,
             t: b.getAttribute('data-title') || '', i: b.getAttribute('data-image') || '',
             pr: +b.getAttribute('data-price') || 0, cap: +b.getAttribute('data-compare') || 0,
             av: b.getAttribute('data-available') === '0' ? 0 : 1 };
  }
  function paintHeart(b) {
    var on = api.has(b.getAttribute('data-tly-wl'));
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.classList.toggle('is-on', on);
    var title = b.getAttribute('data-title') || '';
    b.setAttribute('aria-label', (on ? 'Saved to wishlist: ' : 'Save to wishlist: ') + title);
    var l = b.querySelector('.tly-wl__label');
    if (l) l.textContent = l.getAttribute(on ? 'data-on' : 'data-off');
  }
  var announce = null;
  function say(msg) {
    if (!announce) { announce = document.createElement('div'); announce.className = 'visually-hidden'; announce.setAttribute('aria-live', 'polite'); announce.setAttribute('role', 'status'); document.body.appendChild(announce); }
    announce.textContent = ''; setTimeout(function () { announce.textContent = msg; }, 30);
  }
  function render() {
    var n = state.items.length, i, els;
    els = document.querySelectorAll('[data-tly-wl]'); for (i = 0; i < els.length; i++) paintHeart(els[i]);
    els = document.querySelectorAll('[data-tly-wl-count]'); for (i = 0; i < els.length; i++) { els[i].textContent = n > 99 ? '99+' : n; els[i].hidden = n === 0; }
    els = document.querySelectorAll('[data-tly-wl-count-text]'); for (i = 0; i < els.length; i++) els[i].textContent = n;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[data-tly-wl]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var it = fromButton(b), added = api.toggle(it);
    if (added) { b.classList.remove('tly-pop'); void b.offsetWidth; b.classList.add('tly-pop'); }
    say(added ? 'Saved to wishlist: ' + it.t : 'Removed from wishlist: ' + it.t);
  }, true);
  // cards re-render (collection filters, search): repaint after DOM changes, debounced
  var mo, t;
  function watch() {
    if (!window.MutationObserver) return;
    mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(render, 120); });
    mo.observe(document.body, { childList: true, subtree: true });
  }
  window.addEventListener('storage', function (e) { if (e.key === KEY) { state = load(); render(); renderPage(); } });

  /* ---------- server sync (only with a phone on file) ---------- */
  var apiBase = '', syncT;
  function smsOn() { return state.sms && (state.sms.state === 'confirmed' || state.sms.state === 'pending'); }
  function scheduleSync() { if (!apiBase || !smsOn()) return; clearTimeout(syncT); syncT = setTimeout(syncNow, 1500); }
  function post(path, body) {
    return fetch(apiBase + path, { method: 'POST', mode: 'cors', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { j._status = r.status; return j; }); });
  }
  function syncNow() { post('/wishlist', { id: state.id, items: state.items }).catch(function () {}); }
  api.syncPhone = syncNow;

  /* ---------- wishlist page ---------- */
  var page, grid, emptyEl, live, bornAt = Date.now();
  var fmt = function (c) { c = Math.round(Number(c) || 0); return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var liveData = {}; // handle -> product json

  function cardHTML(it) {
    var lv = liveData[it.h], price = it.pr, cap = it.cap, avail = it.av !== 0, vid = it.v, img = it.i, title = it.t;
    if (!/^[a-z0-9][a-z0-9-]*$/i.test(String(it.h || ''))) return ''; // never render a malformed stored/hydrated item
    if (lv) {
      var v = (lv.variants || []).filter(function (x) { return x.id === it.v; })[0] || (lv.variants || []).filter(function (x) { return x.available; })[0] || (lv.variants || [])[0];
      if (v) { price = v.price; cap = v.compare_at_price || 0; avail = !!v.available; vid = v.id; }
      title = lv.title || title; img = (lv.featured_image && lv.featured_image.replace(/^\/\//, 'https://')) || img;
    }
    var dropped = lv && it.pr && price < it.pr;
    var badges = '';
    if (cap > price) badges += '<span class="tly-wlb tly-wlb--save">Save ' + fmt(cap - price) + '</span>';
    if (!avail) badges = '<span class="tly-wlb tly-wlb--out">Sold out</span>';
    var priceHTML = dropped
      ? '<span class="tly-wlc__now tly-wlc__now--sale">Now ' + fmt(price) + '</span> <s class="tly-wlc__was">was ' + fmt(it.pr) + '</s>'
      : '<span class="tly-wlc__now' + (cap > price ? ' tly-wlc__now--sale' : '') + '">' + fmt(price) + '</span>' + (cap > price ? ' <s class="tly-wlc__was">' + fmt(cap) + '</s>' : '');
    return '<li class="tly-wlc" data-p="' + (Number(it.p) || 0) + '">' +
      '<a class="tly-wlc__media" href="/products/' + esc(it.h) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(title) + '" loading="lazy" width="400" height="400">' : '') +
      '<span class="tly-wlc__badges">' + badges + '</span></a>' +
      '<button type="button" class="tly-wlc__x" data-remove="' + (Number(it.p) || 0) + '" aria-label="Remove ' + esc(title) + ' from wishlist"><svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg></button>' +
      '<a class="tly-wlc__title" href="/products/' + esc(it.h) + '">' + esc(title) + '</a>' +
      '<div class="tly-wlc__price">' + priceHTML + '</div>' +
      '<form class="tly-wlc__form" action="/cart/add" method="post" data-add>' +
      '<input type="hidden" name="id" value="' + (Number(vid) || 0) + '"><input type="hidden" name="quantity" value="1">' +
      '<button type="submit" class="tly-wlbtn tly-wlbtn--solid tly-wlc__add"' + (avail ? '' : ' disabled') + '>' + (avail ? 'Add to cart' : 'Sold out') + '</button></form>' +
      '<p class="tly-wlc__err" role="alert" hidden></p></li>';
  }
  function renderPage() {
    if (!page) return;
    var n = state.items.length;
    grid.innerHTML = state.items.map(cardHTML).join('');
    emptyEl.hidden = n > 0;
    var sms = page.querySelector('[data-tly-wl-sms]'); if (sms) sms.hidden = false;
    if (live) live.textContent = n ? n + (n === 1 ? ' saved item' : ' saved items') : '';
  }
  function fetchLive() {
    var list = state.items.filter(function (it) { return !liveData[it.h]; }), active = 0;
    (function next() {
      while (active < 6 && list.length) {
        (function (it) {
          active++;
          fetch('/products/' + encodeURIComponent(it.h) + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (j) { if (j) { liveData[it.h] = j; renderPage(); } })
            .catch(function () {}).then(function () { active--; next(); });
        })(list.shift());
      }
    })();
  }
  function addToCart(form) {
    var btn = form.querySelector('button'), errEl = form.parentNode.querySelector('.tly-wlc__err');
    errEl.hidden = true; btn.disabled = true; var old = btn.textContent; btn.textContent = 'Adding…';
    var fd = new FormData(form), cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (cart && cart.getSectionsToRender) { fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; })); fd.append('sections_url', window.location.pathname); }
    var url = (window.routes && routes.cart_add_url) || '/cart/add';
    fetch(url + (/\.js$/.test(url) ? '' : '.js'), { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status || res.errors) { errEl.textContent = res.description || res.message || 'We could not add that. Please try again.'; errEl.hidden = false; return; }
        if (cart && cart.renderContents) { cart.renderContents(res); } else { window.location = (window.routes && routes.cart_url) || '/cart'; }
        try { if (window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tly-wishlist', productVariantId: fd.get('id'), cartData: res }); } catch (e) {}
      })
      .catch(function () { errEl.textContent = 'Something went wrong. Please try again.'; errEl.hidden = false; })
      .then(function () { btn.disabled = false; btn.textContent = old; });
  }

  /* ---------- phone box ---------- */
  function initSms() {
    var box = page.querySelector('[data-tly-wl-sms]'); if (!box) return;
    apiBase = (page.getAttribute('data-api') || '').replace(/\/+$/, '');
    var form = box.querySelector('form'), msg = box.querySelector('[data-tly-wl-msg]'), done = box.querySelector('[data-tly-wl-done]'),
        chk = box.querySelector('[data-tly-wl-consent]'), btn = box.querySelector('[data-tly-wl-submit]'), ph = form.phone, started = Date.now();
    function sync() { btn.disabled = !chk.checked; }
    chk.addEventListener('change', sync); sync();
    function showDone(text) { form.hidden = true; box.querySelector('.tly-wlsms__sub').hidden = true; done.hidden = false; done.textContent = text; }
    if (state.sms && state.sms.state === 'confirmed') showDone('Reminders on ✓ ' + (state.sms.masked || '') + ' (Stop anytime: reply STOP)');
    form.addEventListener('submit', function (e) {
      e.preventDefault(); msg.textContent = ''; msg.classList.remove('is-err');
      if (!chk.checked) { msg.textContent = 'Please tick the box to agree to receive texts.'; msg.classList.add('is-err'); return; }
      var digits = ph.value.replace(/\D/g, '');
      if (digits.length < 10) { msg.textContent = 'Please enter a 10-digit US mobile number.'; msg.classList.add('is-err'); ph.focus(); return; }
      btn.disabled = true; btn.textContent = 'Sending…';
      post('/wishlist/phone', { id: state.id, phone: ph.value, consent: true, consent_version: page.getAttribute('data-consent-version'),
                                page_url: location.href.split('#')[0], website: form.website.value, ft: Date.now() - started, items: state.items })
        .then(function (j) {
          if (j.ok) { state.sms = { state: 'confirmed', masked: j.phone_masked || '' }; try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
            showDone(j.welcome === 'sent' ? 'Check your phone — we just texted you. ' + (j.phone_masked || '') : j.welcome === 'already_subscribed_link_sent' ? 'Reminders on ✓ We texted you your list link. (Stop anytime: reply STOP)' : 'Reminders on ✓ (Stop anytime: reply STOP)'); return; }
          msg.textContent = j.message || 'Something went wrong. Please try again.'; msg.classList.add('is-err');
        })
        .catch(function () { msg.textContent = 'We could not reach the server. Please try again.'; msg.classList.add('is-err'); })
        .then(function () { btn.textContent = 'Text me'; sync(); });
    });
    // ?wl=<id> link opened on an empty phone: hydrate from the server
    var m = /[?&]wl=([0-9a-f-]{36})/i.exec(location.search);
    if (m && apiBase && !state.items.length) {
      fetch(apiBase + '/wishlist?id=' + m[1], { mode: 'cors' }).then(function (r) { return r.json(); }).then(function (j) {
        if (j.ok && j.items && j.items.length) { state.id = m[1]; state.items = j.items; if (j.state === 'confirmed') state.sms = { state: 'confirmed', masked: '' }; save(); renderPage(); fetchLive(); }
      }).catch(function () {});
    }
  }
  function initPage() {
    page = document.querySelector('[data-tly-wl-page]'); if (!page) return;
    grid = page.querySelector('[data-tly-wl-grid]'); emptyEl = page.querySelector('[data-tly-wl-empty]'); live = page.querySelector('[data-tly-wl-live]');
    apiBase = (page.getAttribute('data-api') || '').replace(/\/+$/, '');
    page.addEventListener('click', function (e) {
      var x = e.target.closest('[data-remove]'); if (x) { var it = state.items.filter(function (i) { return String(i.p) === x.getAttribute('data-remove'); })[0]; api.remove(x.getAttribute('data-remove')); renderPage(); say('Removed from wishlist' + (it ? ': ' + it.t : '')); }
    });
    page.addEventListener('submit', function (e) { var f = e.target.closest('form[data-add]'); if (f) { e.preventDefault(); addToCart(f); } });
    renderPage(); fetchLive(); initSms();
  }
  function ready() { render(); watch(); initPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
  window.TLYWishlist = api;
})();
